// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Link = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Link = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Link = _exports.Link = function Link(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.6374 11.9138C14.4782 11.9138 14.3182 11.853 14.1965 11.7321C13.9523 11.4888 13.9507 11.093 14.1949 10.848L15.8341 9.19963C16.5074 8.53463 16.8749 7.64297 16.8749 6.68631C16.8749 5.7313 16.5057 4.83628 15.8357 4.16545C14.449 2.77795 12.1907 2.77795 10.8023 4.16545L9.16333 5.81297C8.92 6.05797 8.52413 6.05879 8.27913 5.81546C8.03497 5.57213 8.03316 5.17629 8.27649 4.93129L9.91732 3.28296C11.7948 1.40629 14.8449 1.40795 16.7191 3.28212C17.6257 4.18795 18.1249 5.39714 18.1249 6.68631C18.1249 7.97964 17.6249 9.18631 16.7174 10.0846L15.0815 11.7296C14.9582 11.853 14.7982 11.9138 14.6374 11.9138ZM10.0825 16.7196L11.7315 15.0796C11.9757 14.8363 11.9775 14.4405 11.7333 14.1955C11.49 13.9505 11.0941 13.9505 10.8491 14.193L9.19995 15.8346C7.81328 17.2221 5.55492 17.2221 4.16659 15.8346C2.77909 14.4471 2.7791 12.1896 4.16577 10.803L5.81494 9.16296C6.05911 8.91963 6.06074 8.52379 5.81657 8.27879C5.57324 8.03379 5.17737 8.0338 4.93237 8.2763L3.2832 9.91796C1.4082 11.793 1.4082 14.843 3.2832 16.718C4.22154 17.6555 5.45325 18.1238 6.68408 18.1238C7.91492 18.1238 9.14585 17.6563 10.0825 16.7196ZM7.94161 12.9421L12.9632 7.9213C13.2073 7.67713 13.2073 7.2813 12.9632 7.03713C12.7198 6.7938 12.3242 6.79213 12.0792 7.03713L7.05741 12.058C6.81325 12.3021 6.81325 12.698 7.05741 12.9421C7.17908 13.0638 7.3391 13.1255 7.4991 13.1255C7.6591 13.1255 7.81994 13.0646 7.94161 12.9421Z",
      fill: "#212B36"
    }));
  };
});
